import React from "react";
import { useOutletContext } from "react-router-dom";

import { RegFormContextType } from "../type";
import TicketStatus from "shared/enums/TicketStatus";
import { usePreventBrowserBack } from "shared/hooks/usePreventBrowserBack";
import { useGetInvoicePaymentRequestByRegParticipantIdAndPurchaseOrderId } from "./dataloader";
import { isBulkTicketAdmin } from "apps/registration/utils";
import { InvoicePaymentRequestStatus } from "shared/enums/InvoicePaymentRequestStatus";
import NonAttendeeApplicationStatus from "shared/enums/NonAttendeeApplicationStatus";

/**
 * @name useRegConfirmationService
 * @description this includes logic related to Registration Form
 */

export default function useRegConfirmationService() {
  const { participantObj } = useOutletContext<RegFormContextType>();
  const [showBadgeDetails, setShowBadgeDetails] = React.useState<boolean>(false);
  const { data: transactionDetails } = useGetInvoicePaymentRequestByRegParticipantIdAndPurchaseOrderId(
    participantObj.invoicePayerPaymentRequested,
    participantObj.id,
    participantObj.regPurchaseOrder?.purchaseOrderId as string
  );

  usePreventBrowserBack();

  const forwardedToInvoicePayerAndPaymentPending = React.useMemo(
    () =>
      participantObj?.regPurchaseOrder?.forwardedToInvoicePayer &&
      participantObj?.regPurchaseOrder?.invoicePaymentRequest?.status === InvoicePaymentRequestStatus.PENDING,
    [
      participantObj?.regPurchaseOrder?.forwardedToInvoicePayer,
      participantObj?.regPurchaseOrder?.invoicePaymentRequest?.status
    ]
  );

  const isPaymentReceiptPending = React.useMemo(
    () =>
      participantObj.ticketStatus === TicketStatus.PAYMENT_RECEIPT_PENDING ||
      participantObj.nonAttendeeApplication?.status ===
        NonAttendeeApplicationStatus.BULK_TICKET_PAYMENT_RECEIPT_PENDING,
    [participantObj.ticketStatus, participantObj.nonAttendeeApplication?.status]
  );

  const bulkTicketAdmin = React.useMemo(() => isBulkTicketAdmin(participantObj.subRole), [participantObj.subRole]);

  return {
    showBadgeDetails,
    transactionDetails,
    setShowBadgeDetails,
    bulkTicketAdmin,
    isPaymentReceiptPending,
    forwardedToInvoicePayerAndPaymentPending
  };
}
